import { MicrosoftAppRow } from '../components/MicrosoftAppRow';
import type { AppRow } from '../type/AppRow';

export const microsoftAppRow: AppRow = {
  key: 'microsoft',
  name: 'Microsoft',
  AppComponent: MicrosoftAppRow,
};
